export default {
  '64103b758944c1dd338a19d16fd197d0': 'The first',
  '29881e03534ec25fc024fc8a2e3ff9ee': 'Special offer price',
  '6bbfbac07bc02d84cf76b6c94808d3d5': '"Recommended',
  '89e166a5527c1820e7502975d901e1a7': 'The promotional subscription method has been exposed',
  '5e19d3881fe47d4f49e8f8f8260cfd7d': 'Select the purchase method',
  '2681afdce9e6637e63e8a98d71955b3f':
    'You have activated this product and cannot choose to subscribe',
  d872122a4d76e07589f16484bbdbe824: 'You have subscribed to this product',
  c94c566158c03e0115281016430a258b: 'This subscription model is not supported for the time being',
  '389dabc52aab1c450ddadd2368a8f9d2': 'Equivalent to ¥',
  '5448bc0aeb322d6c73e65fb9918d8e6b': '/ Month',
  c53b9524f9bb83ec41c3f7494ccbe10f: 'Not for purchase',
  '319802382328903b730e54e2cc217d5f': 'time',
  '964ffeab66ae5b5439d02e3a6dd52768': 'Renewal'
};
